import { useRouterState } from '@tanstack/react-router'
import type { FileRouteTypes } from '@/routeTree.gen'

// Policy pages: the fixed bar covers the very text a visitor opened them to read. Settings stay in the footer.
const BANNER_FREE_ROUTE_IDS: readonly FileRouteTypes['id'][] = [
  '/_landing/cookies-policy',
  '/_landing/privacy-policy',
  '/_landing/terms-of-use',
]

// From the router's matches, not the URL, so it follows client-side navigation.
export function useBannerFreeRoute(): boolean {
  return useRouterState({
    select: (state) => state.matches.some((match) => BANNER_FREE_ROUTE_IDS.some((id) => id === match.routeId)),
  })
}
